import * as ActionPartnerTypes from 'actions/partner';

const defaultState = {};

export default function posts(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.DASHBOARD_RECEIVE:
      return action.payload.dashboard;
    case ActionPartnerTypes.DASHBOARD_ACCOUNT_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ASQ_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ASQ_STATS_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ENGAGEMENT_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_INTERACTIVITY_RECEIVE:
      return {...state, ...action.payload};
    case ActionPartnerTypes.DASHBOARD_UPDATE_RECEIVE:
      return {...state, ...action.payload.dashboard};
    default:
      return state;
  }
}
